import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ProfileScreen from './screens/ProfileScreen';
import CheckoutSuccessScreen from './screens/CheckoutSuccessScreen';
import FakeStripeCheckoutScreen from './screens/FakeStripeCheckoutScreen';
import IndicatorsScreen from './screens/IndicatorsScreen';
import FreeScreen from './screens/FreeScreen';
import ResourcesScreen from './screens/ResourcesScreen';
import ArticleScreen from './screens/ArticleScreen';
import CookieConsent from './components/CookieConsent';
import NinjaTraderScreen from './screens/NinjaTraderScreen';
import AdminScreen from './screens/AdminScreen';
import SupportScreen from './screens/SupportScreen';

// Pages légales
import TermsScreen from './screens/legal/TermsScreen';
import PrivacyScreen from './screens/legal/PrivacyScreen';
import CookiePolicyScreen from './screens/legal/CookiePolicyScreen';
import RefundPolicyScreen from './screens/legal/RefundPolicyScreen';
import LegalNoticeScreen from './screens/legal/LegalNoticeScreen';
import DisclosureScreen from './screens/legal/DisclosureScreen';

function App() {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    // ✅ Vérification de cohérence des données utilisateur au démarrage
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        
        // Vérifier que les données sont valides
        if (!parsedUserInfo._id || !parsedUserInfo.token) {
          console.warn('⚠️ Données utilisateur invalides dans localStorage, nettoyage...');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('cartItems');
          localStorage.removeItem('shippingAddress');
          localStorage.removeItem('paymentMethod');
        }
      } catch (error) {
        console.error('❌ Erreur lors du parsing des données utilisateur:', error);
        localStorage.removeItem('userInfo');
        localStorage.removeItem('cartItems');
        localStorage.removeItem('shippingAddress');
        localStorage.removeItem('paymentMethod');
      }
    }
    
    // Ne plus synchroniser le panier
    if (userInfo) {
      // Autres actions à effectuer quand l'utilisateur est connecté
    }
  }, [dispatch, userInfo]);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/product/:id" element={<ProductScreen />} />
            <Route path="/cart" element={<CartScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/register" element={<RegisterScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="/checkout/success" element={<CheckoutSuccessScreen />} />
            <Route path="/checkout/free" element={<FakeStripeCheckoutScreen />} />
            <Route path="/success" element={<CheckoutSuccessScreen />} />
            <Route path="/indicators" element={<IndicatorsScreen />} />
            <Route path="/free" element={<FreeScreen />} />
            <Route path="/resources" element={<ResourcesScreen />} />
            <Route path="/resources/:slug" element={<ArticleScreen />} />
            <Route path="/ninjatrader" element={<NinjaTraderScreen />} />
            <Route path="/admin" element={<AdminScreen />} />
            
            {/* Routes légales */}
            <Route path="/legal" element={<LegalNoticeScreen />} />
            <Route path="/privacy" element={<PrivacyScreen />} />
            <Route path="/terms" element={<TermsScreen />} />
            <Route path="/cookies" element={<CookiePolicyScreen />} />
            <Route path="/refund" element={<RefundPolicyScreen />} />
            <Route path="/disclosure" element={<DisclosureScreen />} />
            
            {/* Route support */}
            <Route path="/support" element={<SupportScreen />} />
          </Routes>
        </main>
        <CookieConsent />
        <Footer />
      </div>
    </Router>
  );
}

export default App; 